import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Industries from "@/components/Industries";
import WhyChoose from "@/components/WhyChoose";
import Workflow from "@/components/Workflow";
import Brands from "@/components/Brands";
import ContactSection from "@/components/ContactSection";
import ProductsPreview from "@/components/ProductsPreview";

export default function Home() {
    return (
        <div data-testid="home-page">
            <Hero />
            <About />
            <ProductsPreview />
            <Services />
            <Industries />
            <WhyChoose />
            <Workflow />
            <Brands />
            <ContactSection />
        </div>
    );
}
